module.exports = __webpack_public_path__ + "static/media/README.b5643b92.md";